import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import SelectChip from '../../../form/component/SelectChip'
import currentUserHasAccess from '../../../../util/widget-helper'
import { PATIENT_IPR_WISHES_WIDGET } from '../../ui-definition/process-ui'
import { ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT } from '../../../anamnesis/state/anamnesis/const'
import BeatLoader from "react-spinners/BeatLoader";

const IPR_WANTED_VALUE = [
    {
        value: true,
        label: 'Yes, patient agrees to IPR if needed',
    },
    {
        value: false,
        label: 'No, patient does not agree to IPR if needed',
    },
]

const WIDGET_TITLE = 'IPR Patient Agreement';

const PatientIPRWishesWidget = ({
    readOnly,
    isIPRProviderStore,
    anamnesis,
    fetching,
    taskName,
    changeAnamnesis,
    saveAnamnesis,
}) => {

    if (!currentUserHasAccess(PATIENT_IPR_WISHES_WIDGET) || !anamnesis) {
        return null
    }

    if (!isIPRProviderStore) {
        if (taskName !== 'medical_assessment') {
            return (
                <ContentBox title={WIDGET_TITLE}>
                    <p>Clinic does not offer IPR</p>
                </ContentBox>
            )
        }

        return null
    }

    const changeFormData = (value) => {
        const payload = {
            ...anamnesis.formData,
            iprAgreed: value,
        }

        changeAnamnesis('formData', payload, ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT);
        saveAnamnesis(ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT);
    }

    // prevent crash during data loading
    if (fetching && !readOnly) {
        return <ContentBox title={WIDGET_TITLE}>
            <Row>
                <Column size={6}>
                    <p>Loading... Please wait.</p>
                    <BeatLoader loading={fetching}/>
                </Column>
            </Row>
        </ContentBox>
    }

    // we use context as object because at the time the widget is used we do not have an anamnesis ready...
    return (
        <ContentBox title={WIDGET_TITLE}>
            <Row>
                <Column size={6}>
                    <LabelInput label="">
                        <SelectChip
                            object={anamnesis.formData}
                            name="iprAgreed"
                            readOnly={readOnly || fetching}
                            addEmpty={true}
                            valueList={IPR_WANTED_VALUE}
                            onChange={(name, value) => {
                                changeFormData(value)
                            }}
                        />
                    </LabelInput>
                </Column>
            </Row>
        </ContentBox>
    )
}

PatientIPRWishesWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    anamnesis: PropTypes.object,
    changeAnamnesis: PropTypes.func.isRequired,
    saveAnamnesis: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    isIPRProviderStore: PropTypes.bool,
    taskName: PropTypes.string.isRequired,
}

export default PatientIPRWishesWidget



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/PatientIPRWishesWidget.js